import { type Component } from 'solid-js';
import Profile from '~/features/profile';

const ProfilePage: Component = () => (
    <div class='flex-1 min-w-0'>
        <Profile />
    </div>
);

export default ProfilePage;
